module.exports = __webpack_public_path__ + "assets/c1171f30b4e5879614db3e81832bbbf0.png";